// Modules
import { URLS } from "utils/constants";
import { Navigate } from "react-router-dom";

// Components
import LaporanBooking from "pages/transaksi/laporan/laporan-booking";
import LaporanProduk from "pages/transaksi/laporan/laporan-produk";
import LaporanPembayaran from "pages/transaksi/laporan/laporan-pembayaran";
import CustomersPage from "pages/v1/customers/customers-page";
import BookingPage from "pages/transaksi/booking/booking-page";
import AgentsPage from "pages/agent/agents-page";
import AgentHistoryPage from "pages/agent/agent-history-page";
import LabelsPage from "pages/label/labels-page";
import ProductPage from "pages/product/product-page";
import MetodePembayaranPage from "pages/metode-pembayaran/metode-pembayaran-page";
import BookingReport from "pages/transaksi/report/booking-report";
import KomisiAgent from "pages/transaksi/report/komisi-agent";
import BookingPageV2 from "pages/transaksi/booking-v2/booking-page-v2";
import TripsPage from "pages/trip/trips-page";
import GuidePage from "pages/guide/guide-page";
import BookingPageV3 from "pages/transaksi/booking-v3/booking-page-v3";
import UsersPage from "pages/user/user-page";
import PhotographerPage from "pages/photographer/photographer-page";
import PermissionMiddleware from "middleware/PermissionMiddleware";
import MealPage from "pages/meal/meal-page";
import DailyReport from "pages/transaksi/report/daily-report";
import BookingPageV4 from "pages/transaksi/booking-v4/booking-page-v4";
import PrintLayoutSettingsPage from "pages/transaksi/booking-v4/print-layout-settings-page";

// Contexts Providers
import { BookingProvider } from "contexts/BookingContext";
import { ProductProvider } from "contexts/v1/masterData/ProductContext";
import { AgentProvider } from "contexts/v1/masterData/AgentContext";
import { LabelProvider } from "contexts/v1/masterData/LabelContext";
import { CustomerProvider } from "contexts/v1/masterData/CustomerContext";
import { TripProvider } from "contexts/v1/masterData/TripContext";
import { KomisiBookingProvider } from "contexts/KomisiBookingContext";
import { GuideProvider } from "contexts/v1/masterData/GuideContext";
import { BookingProviderV3 } from "contexts/v3/BookingContextV3";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { UserProvider } from "contexts/v1/masterData/UserContext";
import { PhotographerProvider } from "contexts/v1/masterData/PhotographerContext";
import { PaymentMethodProvider } from "contexts/v1/masterData/PaymentMethodContext";
import { MealProvider } from "contexts/v1/masterData/MealContext";
import { DailyReportProvider } from "pages/transaksi/report/context/DailyReportContext";
import AccountingPage from "pages/accounting/accounting-page";
import { AccountingProvider } from "pages/accounting/context/AccountingContext";
import { AccountingV2Provider } from "pages/accounting/context/AccountingV2Context";
import AccountingBackupPage from "pages/accounting/AccountingBackupPage";
import { AccountingBackupProvider } from "pages/accounting/context/AccountingBackupContext";
import AccountingV2Page from "pages/accounting/accounting-v2-page";
import FbDailyRecapPage from "pages/accounting/fb-daily-recap-page";
import KeepListPage from "pages/accounting/keep-list-page";
import MasterKeepPage from "pages/accounting/master-keep-page";
import BookkeepingPage from "pages/accounting/bookkeeping-page";
import { DepartmentsProvider } from "pages/hr/master/context/DepartmentsContext";

const queryClient = new QueryClient(); // ✅ Inisialisasi QueryClient

export const bookingRoutes = [
  {
    path: URLS.v1.DASHBOARD,
    // element: <HomePage />,
    element: (
      <PermissionMiddleware
        allowedRoles={["admin", "superadmin", "reservation", "host"]}
        fallback={<Navigate to="/unauthorized" replace />}
      >
        <QueryClientProvider client={queryClient}>
          {" "}
          {/* ✅ Bungkus aplikasi dengan provider */}
          <CustomerProvider>
            <TripProvider>
              <AgentProvider>
                <LabelProvider>
                  <BookingProviderV3>
                    <BookingPageV3 />
                  </BookingProviderV3>
                </LabelProvider>
              </AgentProvider>
            </TripProvider>
          </CustomerProvider>
        </QueryClientProvider>
      </PermissionMiddleware>
    ),
    children: [],
  },

  // booking
  {
    path: URLS.v1.BOOKING,
    element: (
      <BookingProvider>
        <BookingPage />
      </BookingProvider>
    ),
    children: [],
  },
  {
    path: URLS.v1.BOOKINGV2,
    element: (
      <CustomerProvider>
        <TripProvider>
          <AgentProvider>
            <LabelProvider>
              <BookingProvider>
                <BookingPageV2 />
              </BookingProvider>
            </LabelProvider>
          </AgentProvider>
        </TripProvider>
      </CustomerProvider>
    ),
  },
  {
    path: URLS.v1.BOOKINGV3,
    element: (
      <QueryClientProvider client={queryClient}>
        {" "}
        {/* ✅ Bungkus aplikasi dengan provider */}
        <UserProvider>
          <CustomerProvider>
            <TripProvider>
              <AgentProvider>
                <LabelProvider>
                  <BookingProviderV3>
                    <BookingPageV3 />
                  </BookingProviderV3>
                </LabelProvider>
              </AgentProvider>
            </TripProvider>
          </CustomerProvider>
        </UserProvider>
      </QueryClientProvider>
    ),
  },
  {
    path: URLS.v1.BOOKINGV4,
    element: (
      <QueryClientProvider client={queryClient}>
        {" "}
        {/* ✅ Bungkus aplikasi dengan provider */}
        <CustomerProvider>
          <TripProvider>
            <AgentProvider>
              <LabelProvider>
                <BookingProviderV3>
                  <BookingPageV4 />
                </BookingProviderV3>
              </LabelProvider>
            </AgentProvider>
          </TripProvider>
        </CustomerProvider>
      </QueryClientProvider>
    ),
  },
  {
    path: URLS.v1.BOOKINGV4_PRINT_LAYOUT,
    element: (
      <PermissionMiddleware
        allowedRoles={["superadmin", "admin"]}
        fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}
      >
        <PrintLayoutSettingsPage />
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.BOOKINGREPORT,
    element: (
      <PermissionMiddleware
        allowedRoles={["superadmin", "admin"]}
        fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />} // Jika akses tidak diizinkan, arahkan ke halaman Unauthorized gunakan URLS.v1.NOTAUTHORIZED}
      >
        <CustomerProvider>
          <TripProvider>
            <AgentProvider>
              <LabelProvider>
                <BookingProviderV3>
                  <BookingReport />
                </BookingProviderV3>
              </LabelProvider>
            </AgentProvider>
          </TripProvider>
        </CustomerProvider>
      </PermissionMiddleware>
    ),
  },
  // daily report
  {
    path: URLS.v1.DAILYREPORT,
    element: (
      <PermissionMiddleware
        allowedRoles={["superadmin", "admin", "reservation"]}
        fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />} // Jika akses tidak diizinkan, arahkan ke halaman Unauthorized gunakan URLS.v1.NOTAUTHORIZED}
      >
        <TripProvider>
          <KomisiBookingProvider>
            <AgentProvider>
              <DailyReportProvider>
                <DailyReport />
              </DailyReportProvider>
            </AgentProvider>
          </KomisiBookingProvider>
        </TripProvider>
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.KOMISIAGENT,
    element: (
      <PermissionMiddleware
        allowedRoles={["superadmin", "admin", "reservation"]}
        fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />} // Jika akses tidak diizinkan, arahkan ke halaman Unauthorized gunakan URLS.v1.NOTAUTHORIZED}
      >
        <TripProvider>
          <KomisiBookingProvider>
            <AgentProvider>
              <KomisiAgent />
            </AgentProvider>
          </KomisiBookingProvider>
        </TripProvider>
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.LAPORANBOOKING,
    element: (
      <BookingProvider>
        <LaporanBooking />
      </BookingProvider>
    ),
  },
  {
    path: URLS.v1.LAPORANPRODUK,
    element: <LaporanProduk />,
  },
  {
    path: URLS.v1.LAPORANPEMBAYARAN,
    element: <LaporanPembayaran />,
  },

  // MASTERDATA
  {
    path: URLS.v1.CUSTOMERS,
    // element: <CustomersPage />,
    element: (
      <CustomerProvider>
        <CustomersPage />
      </CustomerProvider>
    ),
  },
  {
    path: URLS.v1.AGENTS,
    // element: <AgentsPage />,
    element: (
      <AgentProvider>
        <AgentsPage />
      </AgentProvider>
    ),
  },
  {
    path: URLS.v1.AGENT_HISTORY,
    element: (
      <PermissionMiddleware
        allowedRoles={["superadmin", "admin", "reservation"]}
        fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}
      >
        <AgentHistoryPage />
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.GUIDE,
    element: (
      <PermissionMiddleware
        allowedRoles={["superadmin", "admin"]}
        fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />} // Jika akses tidak diizinkan, arahkan ke halaman Unauthorized gunakan URLS.v1.NOTAUTHORIZED}
      >
        <GuideProvider>
          <GuidePage />
        </GuideProvider>
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.PHOTOGRAPHER,
    element: (
      <PermissionMiddleware
        allowedRoles={["superadmin", "admin"]}
        fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />} // Jika akses tidak diizinkan, arahkan ke halaman Unauthorized gunakan URLS.v1.NOTAUTHORIZED}
      >
        <PhotographerProvider>
          <PhotographerPage />
        </PhotographerProvider>
      </PermissionMiddleware>
    ),
  },

  {
    path: URLS.v1.LABELS,
    // element: <LabelsPage />,
    element: (
      <LabelProvider>
        <LabelsPage />
      </LabelProvider>
    ),
  },
  {
    path: URLS.v1.PRODUCT,
    // element: <ProductPage />,
    element: (
      <ProductProvider>
        <ProductPage />
      </ProductProvider>
    ),
  },
  {
    path: URLS.v1.TRIP,
    element: (
      <TripProvider>
        <TripsPage />
      </TripProvider>
    ),
  },
  {
    path: URLS.v1.METODE_PEMBAYARAN,
    element: (
      <PaymentMethodProvider>
        <MetodePembayaranPage />,
      </PaymentMethodProvider>
    ),
  },
  {
    path: URLS.v1.USER,
    element: (
      <PermissionMiddleware
        allowedRoles={["superadmin"]}
        fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />} // Jika akses tidak diizinkan, arahkan ke halaman Unauthorized gunakan URLS.v1.NOTAUTHORIZED}
      >
        <DepartmentsProvider>
          <UserProvider>
            <UsersPage />
          </UserProvider>
        </DepartmentsProvider>
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.MEAL,
    element: (
      <MealProvider>
        <MealPage />
      </MealProvider>
    ),
  },

  // ACCOUNTING
  {
    path: URLS.v1.ACCOUNTING,
    element: (
      <PermissionMiddleware
        allowedRoles={["superadmin", "accounting"]}
        fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />} // Jika akses tidak diizinkan, arahkan ke halaman Unauthorized gunakan URLS.v1.NOTAUTHORIZED}
      >
        <TripProvider>
          <PaymentMethodProvider>
            <AccountingProvider>
              <AccountingPage />
            </AccountingProvider>
          </PaymentMethodProvider>
        </TripProvider>
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.ACCOUNTING_BACKUP,
    element: (
      <PermissionMiddleware
        allowedRoles={["superadmin", "accounting"]}
        fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}
      >
        <TripProvider>
          <PaymentMethodProvider>
            <AccountingBackupProvider>
              <AccountingBackupPage />
            </AccountingBackupProvider>
          </PaymentMethodProvider>
        </TripProvider>
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.ACCOUNTINGV2,
    element: (
      <PermissionMiddleware
        allowedRoles={["superadmin", "accounting"]}
        fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}
      >
        <TripProvider>
          <PaymentMethodProvider>
            <AccountingV2Provider>
              <AccountingV2Page />
            </AccountingV2Provider>
          </PaymentMethodProvider>
        </TripProvider>
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.ACCOUNTING_BOOKKEEPING,
    element: (
      <PermissionMiddleware
        allowedRoles={["superadmin", "accounting"]}
        fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}
      >
        <BookkeepingPage />
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.ACCOUNTING_FB_DAILY_RECAP,
    element: (
      <PermissionMiddleware
        allowedRoles={["superadmin", "accounting"]}
        fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}
      >
        <FbDailyRecapPage />
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.KEEP_LIST,
    element: (
      <PermissionMiddleware
        allowedRoles={["superadmin", "accounting"]}
        fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}
      >
        <KeepListPage />
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.MASTER_KEEP,
    element: (
      <PermissionMiddleware
        allowedRoles={["superadmin", "accounting"]}
        fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}
      >
        <MasterKeepPage />
      </PermissionMiddleware>
    ),
  },
];
